export default __webpack_public_path__ + "static/glass-7-ee089479871569dbe7848b4aac329e87.jpg";